import { render, staticRenderFns } from "./TournamentRulesModal.vue?vue&type=template&id=4ffd2bd2&"
import script from "./TournamentRulesModal.vue?vue&type=script&lang=js&"
export * from "./TournamentRulesModal.vue?vue&type=script&lang=js&"
import style0 from "./TournamentRulesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports